import { render, staticRenderFns } from "./SelectCoin.vue?vue&type=template&id=4335c395&scoped=true&"
import script from "./SelectCoin.vue?vue&type=script&lang=ts&"
export * from "./SelectCoin.vue?vue&type=script&lang=ts&"
import style0 from "./SelectCoin.vue?vue&type=style&index=0&id=4335c395&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4335c395",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
